"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledDeleteBox = exports.StyledFilter = exports.StyledFilterSection = exports.StyledAddSection = exports.StyledEmpty = exports.StyledFilterBox = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var StyledFilterBox = _styledComponents["default"].div.withConfig({
  displayName: "style__StyledFilterBox",
  componentId: "o4sr4l-0"
})(["position:relative;"]);

exports.StyledFilterBox = StyledFilterBox;

var StyledEmpty = _styledComponents["default"].div.withConfig({
  displayName: "style__StyledEmpty",
  componentId: "o4sr4l-1"
})(["max-width:300px;margin:0 auto;text-align:center;"]);

exports.StyledEmpty = StyledEmpty;

var StyledAddSection = _styledComponents["default"].div.withConfig({
  displayName: "style__StyledAddSection",
  componentId: "o4sr4l-2"
})(["position:absolute;top:-40px;right:0;"]);

exports.StyledAddSection = StyledAddSection;

var StyledFilterSection = _styledComponents["default"].div.withConfig({
  displayName: "style__StyledFilterSection",
  componentId: "o4sr4l-3"
})(["padding:10px 0;position:relative;label{text-transform:capitalize;}"]);

exports.StyledFilterSection = StyledFilterSection;

var StyledFilter = _styledComponents["default"].div.withConfig({
  displayName: "style__StyledFilter",
  componentId: "o4sr4l-4"
})(["padding:15px 0 0 20px;margin:0 0 0 10px;border-left:1px solid #d2d3d6;"]);

exports.StyledFilter = StyledFilter;

var StyledDeleteBox = _styledComponents["default"].div.withConfig({
  displayName: "style__StyledDeleteBox",
  componentId: "o4sr4l-5"
})(["position:absolute;right:0;top:50%;transform:translate(-50px,-50%);button{font-size:12px;padding:7px 10px;border:none;font-weight:500;}"]);

exports.StyledDeleteBox = StyledDeleteBox;